import { useEffect, useState } from "react";

import { useTime } from "@smart/itops-hooks-dom";
import { Button } from "@smart/itops-sb-design-system-dom";

type TabListStatusProps = {
  refetching: boolean;
  onRefetch: () => void;
};

export const TabListStatus = ({
  refetching,
  onRefetch,
}: TabListStatusProps) => {
  const [refreshDateTime, setRefreshDateTime] = useState(new Date());

  const refreshedAt = useTime(refreshDateTime, { lowercase: true });

  useEffect(() => {
    if (!refetching) {
      setRefreshDateTime(new Date());
    }
  }, [refetching]);

  return (
    <div className="flex flex-row items-center gap-small h-[4.8rem] fixed w-full bg-white border-t border-t-neutral-100 bottom-0 pl-[2.4rem]">
      <span className="text-ui">Last refreshed {refreshedAt}</span>
      <Button
        leftIcon="regularArrowsRotate"
        variant="highlight"
        aria-label="Refresh Forms"
        onClick={() => {
          if (!refetching) {
            onRefetch();
          }
        }}
      />
    </div>
  );
};
